<div class="pl-md-4 pt-3" *ngIf="loadingCustomer || loadingOrganizationConfig">
  <h2>Loading...</h2>
</div>

<div class="pl-md-4 pt-3" *ngIf="customerNotFound">
  <h2>Customer Not Found</h2>
</div>

<div class="pl-md-4 pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="row pl-xl-4 pt-4 mb-6" *ngIf="!loadingCustomer && !loadingOrganizationConfig && !customerNotFound && (serverError === null)">
  <div class="alert customer-alert text-center" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="alert customer-alert text-center" role="alert"
       [class.alert-success]="modalResult.status === CallbackResultStatus.success"
       *ngIf="modalResult !== null">
    {{ modalResult.text }}
  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert"
         *ngIf="allthenticateSuccessMessage">
      {{ allthenticateSuccessMessage }}
      <button type="button" class="close" aria-label="Close"
              (click)="allthenticateSuccessMessage = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-danger alert-dismissible" role="alert"
         *ngIf="allthenticateErrorMessage">
      {{ allthenticateErrorMessage }}
      <button type="button" class="close" aria-label="Close"
              (click)="allthenticateErrorMessage = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="alert alert-danger alert-dismissible" role="alert"
         *ngIf="backgroundRefreshErrorMessage">
      {{ backgroundRefreshErrorMessage }}
      <button type="button" class="close" aria-label="Close"
              (click)="backgroundRefreshErrorMessage = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>

  <div class="alert customer-alert alert-info" role="alert" *ngIf="loadingAnyAlertCategory()">
    Loading alerts...
  </div>

  <ng-container *ngIf="customerProfileDetails && !loadingCustomerProfileDetails">
    <div *ngFor="let checkInAlert of customerProfileDetails.check_in_alerts"
         class="alert customer-alert alert-danger text-center" role="alert">
      {{ checkInAlert }}
    </div>
  </ng-container>

  <ng-container *ngIf="invalidDocInboxItemResultsPresent() && !loadingInvalidDocInboxItems">
    <div *ngFor="let invalidDocInboxItem of invalidDocInboxItemsList"
         class="alert alert-danger customer-alert" role="alert">
      An invalid document is pending review for this customer.
      <a href="#"
         (click)="openReviewInvalidDocumentInboxItemModal(invalidDocInboxItem);$event.preventDefault();">
        Review the document.
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="!loadingDocuments">
    <div *ngFor="let docPendingStaffReview of getDocumentsPendingStaffReview()"
         class="alert alert-warning customer-alert" role="alert">
      A document is pending staff approval for this customer.
      <a href="#"
         (click)="openReviewDocumentPendingStaffApprovalModal(docPendingStaffReview);$event.preventDefault();">
        Review the document.
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="!loadingPendingRelations">
    <div *ngFor="let pendingRelation of getRelationsPendingStaffApproval()"
         class="alert alert-warning customer-alert" role="alert">
      {{ customer.first_name }} {{ customer.last_name }} requested a link to
      {{ pendingRelation.related_customer_first_name }}
      {{ pendingRelation.related_customer_last_name}}.
      <a href="#"
         (click)="openReviewPendingLinkedAccountModal(pendingRelation);$event.preventDefault();">
        Click here to review.
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="!loadingIncomingPendingRelations">
    <div *ngFor="let pendingRelation of getIncomingRelationsPendingStaffApproval()"
         class="alert alert-warning customer-alert" role="alert">
      {{ pendingRelation.requesting_customer_first_name }}
      {{ pendingRelation.requesting_customer_last_name}}
      requested a link to {{ customer.first_name }} {{ customer.last_name }} .
      <a href="#"
         (click)="openReviewIncomingPendingLinkedAccountModal(pendingRelation);$event.preventDefault();">
        Click here to review.
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="!loadingCustomerChallenges">
    <div *ngFor="let challengeAwaitingPrize of getChallengesAwaitingPrizes()"
         class="alert alert-warning customer-alert" role="alert">
      {{ customer.first_name }} {{ customer.last_name }} is awaiting a prize for the {{ challengeAwaitingPrize.challenge_name }} challenge.
      <a href="#"
         (click)="openCustomerChallengeModal(challengeAwaitingPrize);$event.preventDefault();">
        Review the challenge.
      </a>
    </div>
  </ng-container>

  <ng-container *ngIf="!loadingAssociations">

    <div *ngFor="let amPendingReverification of getAlertableAssociationMembershipsPendingReverification()"
         class="alert alert-warning customer-alert" role="alert">
      {{ customer.first_name }} {{ customer.last_name }} must re-verify that they are part of {{ amPendingReverification.association_name }} before
      {{ dateStringFromISO8601(amPendingReverification.next_automatic_removal_datetime) }}.
      <a href="#"
         (click)="editAssociationForCustomer(amPendingReverification);$event.preventDefault();">
        Click here to review.
      </a>
    </div>

    <div *ngFor="let amPendingReview of getAssociationJoinRequests()"
         class="alert alert-warning customer-alert" role="alert">
      {{ customer.first_name }} {{ customer.last_name }} has requested to join {{ amPendingReview.association_name }}.
      <a href="#"
         (click)="reviewAssociationJoinRequest(amPendingReview);$event.preventDefault();">
        Click here to review.
      </a>
    </div>

  </ng-container>

  <div *ngFor="let dup of potentialDuplicatesList"
       class="alert alert-warning customer-alert" role="alert">
    A potential duplicate account has been identified for this customer.
    <a href="#"
       (click)="reviewPotentialDuplicate(dup);$event.preventDefault();">
      Click here to review.
    </a>
  </div>

  <div *ngFor="let cii of getCustomInboxItemsWithAlerts()"
       class="alert customer-alert text-center" role="alert"
       [ngStyle]="getCustomerAlertStyle(cii.inbox_customer_profile_alert_color_hex)">
    <button class="btn btn-outline-primary alert-dismiss-btn"
              (click)="reviewCustomInboxItem(cii)">
      Review
    </button>

    This customer is in the following custom inbox: {{ cii.inbox_name }}.
    <small class="d-block">
      Added to inbox on
      {{ dateStringFromISO8601(cii.created_at, orgConfig ? orgConfig.time_zone : null) }}
    </small>
  </div>

  <ng-container *ngIf="alertResultsPresent() && !loadingAlerts">
    <div *ngFor="let customerAlert of alertsList.results"
         class="alert customer-alert text-center" role="alert"
         [ngStyle]="getCustomerAlertStyle(customerAlert.color_hex)">
      <button class="btn btn-outline-primary alert-dismiss-btn disabled" disabled
              *ngIf="loadingDismissAlert[customerAlert.id]">
        Loading...
      </button>
      <button class="btn btn-outline-primary alert-dismiss-btn"
              *ngIf="!loadingDismissAlert[customerAlert.id]"
              (click)="dismissAlert(customerAlert)">
        Dismiss
      </button>

      {{ customerAlert.alert_text }}
      <small class="d-block">
        Alert created on
        {{ dateStringFromISO8601(customerAlert.created_at, orgConfig ? orgConfig.time_zone : null) }}
      </small>
      <small class="d-block" *ngIf="getAlertDetailText(customerAlert)">
        {{ getAlertDetailText(customerAlert) }}
      </small>
    </div>
  </ng-container>

  <div class="col-xl-8">
    <div class="row">
      <div class="col-12 col-md-4 pr-md-0 mb-3 mb-md-0">
        <div class="rounded-border rounded-tight p-2" style="height: 300px">
          <img *ngIf="!customer.profile_image"
               src="/assets/images/photo_placeholder.png"
               class="customer-photo my-2">
          <img *ngIf="customer.profile_image"
               [src]="customer.profile_image"
               class="customer-photo my-2">
          <p class="customer-name">{{ customerName() }}</p>
          <p class="customer-contact">{{ getFieldValue(orgConfig.profile_contact_field) }}</p>
          <div class="row">
            <div class="col">
              <p class="main-item-value">{{ getFieldValue(orgConfig.major_profile_field_1) }}</p>
              <p class="main-item-label">{{ getThisCustomerFieldLabel(orgConfig.major_profile_field_1) }}</p>
            </div>
            <div class="col">
              <p class="main-item-value">{{ getFieldValue(orgConfig.major_profile_field_2) }}</p>
              <p class="main-item-label">{{ getThisCustomerFieldLabel(orgConfig.major_profile_field_2) }}</p>
            </div>
          </div>
          <div style="position: absolute; bottom: 4px;">
            <ng-container *ngIf="customer && customerProfileDetails">
              <div *ngIf="customer.has_medical_notes"
                   ngbTooltip="Has medical notes"
                   class="d-inline">
                <app-medical-notes-icon [size]="0"></app-medical-notes-icon>
              </div>
              <div *ngIf="customerProfileDetails.has_alert_icon"
                   ngbTooltip="Has a profile alert"
                   class="d-inline">
                <app-alert-icon [size]="0"></app-alert-icon>
              </div>
              <div *ngFor="let proficiency of customerProfileDetails.active_proficiencies"
                   class="d-inline"
                   [ngbTooltip]="proficiency.proficiency_name">
                <app-proficiency-icon [colorHex]="proficiency.proficiency_icon_color_hex"
                                      [iconInitials]="proficiency.proficiency_icon_initials"
                                      [size]="0">
                </app-proficiency-icon>
              </div>
              <div *ngFor="let icon of customerProfileDetails.membership_icons"
                   class="d-inline"
                   [ngbTooltip]="icon.icon_hover_text">
                <app-membership-icon [colorHex]="icon.icon_color_hex"
                                     [iconInitials]="icon.icon_initials"
                                     [size]="0"
                                     style="padding-right:1px">
                </app-membership-icon>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="rounded-border rounded-tight p-2" style="height: 300px">
          <div class="row">
            <div class="col">
              <!--
                Action buttons; those that don't fit overflow into "More"
                (`appOverflowMenu`). Order comes from the profile layout config.
              -->
              <div appOverflowMenu [(visibleCount)]="visibleActionButtonCount"
                   class="profile-action-buttons d-flex align-items-start">
                <!--
                  Keep the inline and "More" renderings in sync, the tooltip
                  included (PRO-1239). Not a shared template: the dropdown items
                  need ngbDropdownItem for keyboard navigation.
                -->
                <div *ngFor="let btn of actionButtons; trackBy: trackActionButton; let i = index"
                     #overflowItem
                     class="mr-2 mb-2"
                     [class.overflow-item-hidden]="i >= visibleActionButtonCount">
                  <a *ngIf="btn.routerLink"
                     [routerLink]="btn.routerLink"
                     [queryParams]="btn.queryParams || null"
                     [ngbTooltip]="btn.tooltip || null" placement="bottom"
                     class="btn btn-sm btn-outline-primary text-nowrap">
                    {{ btn.label }}
                  </a>
                  <button *ngIf="!btn.routerLink" type="button"
                          (click)="btn.onClick && btn.onClick()"
                          [ngbTooltip]="btn.tooltip || null" placement="bottom"
                          class="btn btn-sm btn-outline-primary text-nowrap">
                    {{ btn.label }}
                  </button>
                </div>
                <div *ngIf="visibleActionButtonCount < actionButtons.length"
                     ngbDropdown placement="bottom-right"
                     class="profile-action-buttons-more mb-2">
                  <button #overflowMore ngbDropdownToggle type="button"
                          class="btn btn-sm btn-outline-primary text-nowrap">
                    More
                  </button>
                  <div ngbDropdownMenu>
                    <ng-container *ngFor="let btn of actionButtons.slice(visibleActionButtonCount)">
                      <a *ngIf="btn.routerLink" ngbDropdownItem
                         [routerLink]="btn.routerLink"
                         [queryParams]="btn.queryParams || null"
                         [ngbTooltip]="btn.tooltip || null" placement="left">
                        {{ btn.label }}
                      </a>
                      <button *ngIf="!btn.routerLink" ngbDropdownItem type="button"
                              (click)="btn.onClick && btn.onClick()"
                              [ngbTooltip]="btn.tooltip || null" placement="left">
                        {{ btn.label }}
                      </button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3 mt-4">
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_1) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_1) }}</p>
            </div>
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_2) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_2) }}</p>
            </div>
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_3) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_3) }}</p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_4) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_4) }}</p>
            </div>
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_5) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_5) }}</p>
            </div>
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_6) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_6) }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_7) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_7) }}</p>
            </div>
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_8) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_8) }}</p>
            </div>
            <div class="col">
              <p class="grid-item-label">{{ getThisCustomerFieldLabel(orgConfig.minor_profile_field_9) }}</p>
              <p class="grid-item-value">{{ getFieldValue(orgConfig.minor_profile_field_9) }}</p>
            </div>
          </div>
          <div style="position: absolute; bottom: 6px;">
            <span class="ml-1"
                  [ngbTooltip]="getLastActivityDetail()">
              {{ getLastActivityShort() }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!--
      Sub-list nav. Items that don't fit at the current width collapse into a
      right-aligned "More" dropdown, driven by the shared `appOverflowMenu`
      directive.
    -->
    <nav appOverflowMenu [(visibleCount)]="visibleNavCount"
         class="navbar navbar-expand navbar-light bg-light rounded-border rounded-tight profile-nav mt-3"
         style="padding-left: 8px;padding-right: 0;">
      <ul class="navbar-nav profile-nav-list">
        <li *ngFor="let item of navItems; let i = index"
            #overflowItem
            class="nav-item"
            [class.overflow-item-hidden]="i >= visibleNavCount">
          <a [routerLink]="item.routerLink" routerLinkActive="active"
             class="nav-link text-nowrap" href="#">
            {{ item.label }}
          </a>
        </li>
      </ul>
      <div *ngIf="visibleNavCount < navItems.length"
           ngbDropdown placement="bottom-right"
           class="profile-nav-more ml-auto">
        <a #overflowMore ngbDropdownToggle
           class="nav-link profile-nav-more-toggle text-nowrap"
           [class.active]="isMoreActive()"
           href="javascript:void(0)">
          More
        </a>
        <div ngbDropdownMenu>
          <a *ngFor="let item of navItems.slice(visibleNavCount)"
             ngbDropdownItem
             [routerLink]="item.routerLink" routerLinkActive="active"
             href="#">
            {{ item.label }}
          </a>
        </div>
      </div>
    </nav>

    <router-outlet></router-outlet>

  </div>

  <div class="col-xl-4">

    <ng-container *ngFor="let card of sidebarOrder" [ngSwitch]="card">

    <div *ngSwitchCase="CustomerProfileSidebarCard.emergencyContacts"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Emergency Contacts</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddEmergencyContactModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="emergencyContactResultsPresent()">
        <tr *ngFor="let emergencyContact of emergencyContactsList.results"
            (click)="openEditEmergencyContactModal(emergencyContact)">
          <td>
            {{ emergencyContact.first_name }} {{ emergencyContact.last_name }}<span *ngIf="emergencyContact.relation">, <i>{{ emergencyContact.relation }}</i></span>
          </td>
          <td class="text-muted text-right">{{ emergencyContact.telephone }}</td>
        </tr>
      </tbody>

      <tbody *ngIf="!emergencyContactResultsPresent()">
      <tr>
        <td colspan="99" class="text-muted">
          {{ loadingEmergencyContacts ? 'Loading...' : 'No emergency contacts' }}
        </td>
      </tr>
      </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.medicalInfo"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Medical Info</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddMedicalNotesModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="medicalNotesResultsPresent()">
        <tr *ngFor="let medicalNotes of medicalNotesList.results"
            (click)="openMedicalNotesModal(medicalNotes)">
          <td>Medical Notes</td>
          <td class="text-muted text-right">Added {{ dateStringFromISO8601(medicalNotes.updated_at) }}</td>
        </tr>
        </tbody>

        <tbody *ngIf="!medicalNotesResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingMedicalNotes ? 'Loading...' : 'No medical info' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.proficiency"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Proficiency</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddProficiencyModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="proficiencyResultsPresent()">
        <tr *ngFor="let proficiency of proficienciesList.results"
            [class.font-italic]="proficiency.proficiency_is_removed"
            (click)="openEditProficiencyModal(proficiency)">
          <td>{{ proficiency.proficiency_name }}</td>
          <td class="{{ getProficiencyExpirationDisplay(proficiency).className }} text-right">
            {{ getProficiencyExpirationDisplay(proficiency).displayText }}
          </td>
        </tr>
        </tbody>

        <tbody *ngIf="!proficiencyResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingProficiencies ? 'Loading...' : 'No proficiency' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.notes"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Notes</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddNoteModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="noteResultsPresent()">
        <tr *ngFor="let note of notesList.results"
            (click)="openNoteModal(note)">
          <td>{{ note.title }}</td>
          <td class="text-muted" style="white-space: nowrap">
            {{ dateStringFromISO8601(note.updated_date) }}
          </td>
        </tr>
        </tbody>

        <tbody *ngIf="!noteResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingNotes ? 'Loading...' : 'No notes' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.documents"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Documents</p>
      <a href="#" class="side-table-add-icon"
         (click)="openOpenDocumentForCustomerModal();$event.preventDefault();">
        +
      </a>
      <table class="table">
        <tbody *ngIf="documentResultsPresent()">
        <tr *ngFor="let document of documentsList.results">
          <td>
            <a *ngIf="document.pdf" href="{{ document.pdf }}" target="_blank">{{ document.name }}</a>
            <span *ngIf="!document.pdf">{{ document.name }}</span>
          </td>
          <td *ngIf="!document.is_pending_staff_approval" class="text-right table-btn-sm-on-parent-hover">
            <span class="{{ getDocumentExpirationDisplay(document).className }} hide-on-grandparent-hover">
              {{ getDocumentExpirationDisplay(document).displayText }}
            </span>
            <a href="#" class="btn btn-outline-secondary btn-sm show-on-grandparent-hover"
               (click)="openManageDocumentModal(document);$event.preventDefault();">
              Manage
            </a>
          </td>
          <td *ngIf="document.is_pending_staff_approval" class="text-right table-btn-sm">
            <a href="#" class="btn btn-outline-primary btn-sm"
               (click)="openReviewDocumentPendingStaffApprovalModal(document);$event.preventDefault();">
              Pending Approval
            </a>
          </td>
        </tr>
        </tbody>

        <tbody *ngIf="!documentResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingDocuments ? 'Loading...' : 'No documents' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.challenges"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Challenges</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddCustomerToChallengeModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="customerChallengeResultsPresent()">
        <tr *ngFor="let challenge of customerChallengesList.results"
            (click)="openCustomerChallengeModal(challenge)">
          <td>{{ challenge.challenge_name }}</td>
          <td class="text-right">
            <span *ngIf="challenge.is_complete" class="text-success">
              <ng-container *ngIf="challenge.challenge_will_prompt_for_prize">
                {{ challenge.prize_given ? 'Prize Received' : 'Awaiting Prize' }}
              </ng-container>
              <ng-container *ngIf="!challenge.challenge_will_prompt_for_prize">
                Complete
              </ng-container>
            </span>
            <ng-container *ngIf="!challenge.is_complete">
              <span *ngIf="challenge.challenge_has_ended" class="text-danger">
                Incomplete ({{ challenge.count }}/{{ challenge.challenge_goal }})
              </span>
              <span *ngIf="!challenge.challenge_has_ended">
                {{ challenge.count }}/{{ challenge.challenge_goal }}
              </span>
            </ng-container>
          </td>
        </tr>
        </tbody>

        <tbody *ngIf="!customerChallengeResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingCustomerChallenges ? 'Loading...' : 'No challenges' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.linkedAccounts"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Linked Accounts</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddLinkedAccountModal();$event.preventDefault();">
        +
      </a>
      <table class="table">
        <tbody *ngIf="linkedAccountsResultsPresent()">

        <ng-container *ngIf="pendingRelationResultsPresent()">
          <tr *ngFor="let pendingRelation of pendingRelationsList.results">

            <td>
              <a [routerLink]="['/customers', pendingRelation.related_customer_id.toString()]">
                {{ pendingRelation.related_customer_first_name }} {{ pendingRelation.related_customer_last_name }}
              </a>
            </td>

            <td class="text-right text-muted"
                *ngIf="pendingRelation.status === PendingRelationStatus.pendingRelatedCustomerApproval">
              Pending Customer Approval
            </td>
            <td class="text-right table-btn-sm"
                *ngIf="pendingRelation.status === PendingRelationStatus.pendingStaffApproval">
              <a href="#" class="btn btn-outline-primary btn-sm"
                 (click)="openReviewPendingLinkedAccountModal(pendingRelation);$event.preventDefault();">
                Pending Approval
              </a>
            </td>

          </tr>
        </ng-container>

        <ng-container *ngIf="incomingPendingRelationResultsPresent()">
          <tr *ngFor="let pendingRelation of incomingPendingRelationsList.results">

            <td>
              <a [routerLink]="['/customers', pendingRelation.requesting_customer_id.toString()]">
                {{ pendingRelation.requesting_customer_first_name }} {{ pendingRelation.requesting_customer_last_name }}
              </a>
            </td>

            <td class="text-right text-muted"
                *ngIf="pendingRelation.status === PendingRelationStatus.pendingRelatedCustomerApproval">
              Pending Customer Approval
            </td>
            <td class="text-right table-btn-sm"
                *ngIf="pendingRelation.status === PendingRelationStatus.pendingStaffApproval">
              <a href="#" class="btn btn-outline-primary btn-sm"
                 (click)="openReviewIncomingPendingLinkedAccountModal(pendingRelation);$event.preventDefault();">
                Pending Approval
              </a>
            </td>

          </tr>
        </ng-container>

        <ng-container *ngIf="relationResultsPresent()">
          <tr *ngFor="let relation of relationsList.results">
            <td>
              <a [routerLink]="['/customers', relation.related_customer_id.toString()]">
                {{ relation.related_customer_first_name }} {{ relation.related_customer_last_name }}
              </a>
            </td>
            <td class="text-right table-btn-sm-on-parent-hover" style="min-width: 97px;">
              <span class="text-muted hide-on-grandparent-hover">
                {{ getRelationTypeDisplay(relation.relation) }}
              </span>
              <a href="#" class="btn btn-outline-danger btn-sm show-on-grandparent-hover"
                 (click)="openConfirmRemoveLinkedAccountModal(relation);$event.preventDefault();">
                Remove Link
              </a>
            </td>
          </tr>
        </ng-container>

        </tbody>

        <tbody *ngIf="!linkedAccountsResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingRelations ? 'Loading...' : 'No linked accounts' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.associations"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Associations</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddCustomerToAssociationModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="associationResultsPresent()">
        <tr *ngFor="let associationMember of associationsList.results"
            (click)="handleAssociationMemberClick(associationMember)">
          <td>
            {{ associationMember.association_name }}
            <span *ngIf="associationMember.has_pending_application" class="text-warning">- Pending</span>
          </td>
        </tr>
        </tbody>

        <tbody *ngIf="!associationResultsPresent()">
        <tr>
          <td colspan="99" class="text-muted">
            {{ loadingAssociations ? 'Loading...' : 'No associations' }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div *ngSwitchCase="CustomerProfileSidebarCard.tags"
         class="rounded-border rounded-tight p-3 mb-3">
      <p class="side-table-header">Tags</p>
      <a href="#" class="side-table-add-icon"
         (click)="openAddTagModal();$event.preventDefault();">
        +
      </a>
      <table class="table table-hover">
        <tbody *ngIf="customer.tags.length > 0">
        <tr *ngFor="let tag of customer.tags" (click)="openEditTagModal(tag)">
          <td>{{ tag }} </td>
        </tr>
        </tbody>

        <tbody *ngIf="customer.tags.length <= 0">
        <tr>
          <td colspan="99" class="text-muted">
            No tags
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <ng-container *ngSwitchCase="CustomerProfileSidebarCard.allthenticateStatus">
      <!-- The sidebar-order config filters this card out for orgs that do
           not use it; the profile reconciles the stored order instead, so it
           needs its own check. -->
      <div *ngIf="usesSpecificAllthenticateProducts()"
           class="rounded-border rounded-tight p-3 mb-3">
        <p class="side-table-header">Allthenticate Status</p>
        <table class="table">
          <tbody>
          <tr>
            <td>Account</td>
            <td class="text-muted text-right">
              {{ customer.has_allthenticate_account ? 'Active' : 'No account' }}
            </td>
          </tr>
          <tr>
            <td>Last Invite</td>
            <td class="text-muted text-right">
              {{ customer.allthenticate_invite_sent_at
                  ? dateStringFromISO8601(customer.allthenticate_invite_sent_at)
                  : 'Never' }}
            </td>
          </tr>
          </tbody>
        </table>
        <div class="d-flex" style="gap: 12px;">
          <button type="button" class="btn btn-outline-primary btn-sm"
                  [disabled]="loadingSendAllthenticateInvite"
                  [class.disabled]="loadingSendAllthenticateInvite"
                  (click)="sendAllthenticateInvite()">
            {{ loadingSendAllthenticateInvite ? 'Sending...' : 'Send Invite' }}
          </button>
          <button type="button" class="btn btn-outline-danger btn-sm"
                  *ngIf="customer.has_allthenticate_account"
                  [disabled]="loadingRemoveAllthenticateAccess"
                  [class.disabled]="loadingRemoveAllthenticateAccess"
                  (click)="removeAllthenticateAccess()">
            {{ loadingRemoveAllthenticateAccess ? 'Removing...' : 'Remove' }}
          </button>
        </div>
      </div>
    </ng-container>

    </ng-container>

  </div>
</div>
